/**
 * What each admin console is called, in its sidebar entry, breadcrumb and
 * heading alike.
 *
 * @module router/admin/admin-area
 */

export const ADMIN_AREA = {
  client: "Users and settings",
  platform: "Tenant Management",
} as const;
